<template>
	<div>
		<div class="block-top" v-if="fangxiang == 'left'">
			<div class="block-top-title">
				<i class="el-icon-caret-right"></i>
				<div style="display: flex;"><span class="title">{{ title }}</span>
					<dv-decoration-1 style="width:100px;height:30px;" />
				</div>
			</div>
			<span @click="$emit('more')" class="block-top_more" v-if="showUnitLabel">单位：{{ danwei }}
				<div class="box-line"></div>
			</span>
		</div>
		<div class="block-top" v-if="fangxiang == 'right'">
			<div class="block-top-title">
				<i class="el-icon-caret-right"></i>
				<!-- <span style="font-size:1.8vh;font-weight: 600;color: #fff">{{ title }}</span> -->
				<div style="display: flex;"><span class="title">{{ title }}</span>
					<dv-decoration-1 style="width:100px;height:30px;" />
				</div>
			</div>
			<span @click="$emit('more')" class="block-top_more" v-if="showUnitLabel">单位：{{ danwei }}
				<div class="box-line"></div>
			</span>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			title: String,
			showDanwei: {
				type: Boolean,
				default: true,
			},
			fangxiang: String,
			danwei: String,
		},
		computed: {
			showUnitLabel() {
				if (!this.showDanwei) return false;
				const value = String(this.danwei || '').trim();
				if (!value) return false;
				return !['--', '-', '无', '暂无'].includes(value);
			},
		},
	};
</script>

<style lang="scss">
	.block-top {
		width: 100%;
		height: 30px;
		display: flex;
		align-items: center;
		background-image: url("../assets/titlebgimg.png");
		background-size: 100% 100%;
	}

	.el-icon-caret-right {
		font-size: 25px;
		color: #00ffff;
		margin-right: 5px;
	}

	.block-top-title {
		width: 100%;
		display: flex;
		padding-left: 50px;
		align-items: center;
	}

	.box-line {
		width: 5px;
		height: 20px;
		border-radius: 20px;
		background-color: #ffff7f;
		margin: 0px 5px;
	}

	.title {
		font-size: 1.8vh;
		font-weight: 600;
		color: #fff;
		display: flex;
		    align-items: center;
	}

	.block-top_more {
		width: 200px;
		color: #fff;
		font-size: 0.8vw;
		font-weight: 600;
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}
</style>